// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3GvcM","footer":"ChangeClinic_footer__3balu"};